const collection_data = [
  
  
  {
    id:1,
    img:'/assets/img/artwork/projapp.jpg',
    name:'Mobile App',
    author:'YazoiLup'
  },
  {
    id:2,
    img:'/assets/img/artwork/projcard.jpg',
    name:'Virtual Card',
    author:'CryptoX'
  },
  {
    id:3,
    img:'/assets/img/artwork/projnft.jpg',
    name:'NFT MARKET',
    author:'Texira'
  },
  {
    id:4,
    img:'/assets/img/artwork/projairdrop.jpg',
    name:'Air Drop',
    author:'GeorgZvic'
  },
 
  {
    id:6,
    img:'/assets/img/artwork/projbot.jpg',
    name:'AI Trading Bot',
    author:'Buy and exchange PAI token easily'
  },
  {
    id:6,
    img:'/assets/img/artwork/projcopy.jpg',
    name:'Copy Trading',
    author:'Buy and exchange PAI token easily'
  },
  {
    id:7,
    img:'/assets/img/artwork/projgame.jpg',
    name:'Crypto Game',
    author:'Buy and exchange PAI token easily'
  },
  {
    id:5,
    img:'/assets/img/artwork/projstaking.jpg',
    name:'Staking',
    author:'Buy and exchange PAI token easily'
  },
]

export default collection_data;